export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/icomoon.047fc7b8.woff";